const GrammarSection = ({ grammar }) => {
  return (
    <div className="writingGradeSectionContainer">
      <div className="writingGradeSectionHeaderContainer">
        <h2 className="writingGradeSectionHeader">
          Grammar / Spelling - Score {grammar.Score}/10 (30% of total grade)
        </h2>
      </div>
      <div className="writingGradeSectionBodyContainer">
        <h3 className="writingGradeSectionSubheader">Comments</h3>
        <p className="writingGradeSectionText">{grammar.Feedback}</p>
        <h3 className="writingGradeSectionSubheader">Grammatical Errors</h3>
        <div className="writingGradeSectionSubsectionWrapper writingGradeSectionTwoColumnSubsection">
          {grammar.GrammaticalErrors.map((error) => (
            <div className="writingGradeSectionErrorCardContainer">
              <div
                className="writingGradeSectionErrorCardContentWrapper"
                key={`grammarError-${error.Error}`}
              >
                <h4 className="writingGradeSectionErrorCardErrorText">Error</h4>
                <p className="writingGradeSectionErrorCardSubtext">
                  {error.Error}
                </p>
              </div>
              <div className="writingGradeSectionErrorCardContentWrapper">
                <h4 className="writingGradeSectionErrorCardCorrectionText">
                  Correction
                </h4>
                <p className="writingGradeSectionErrorCardSubtext">
                  {error.Correction}
                </p>
              </div>
            </div>
          ))}
        </div>
        <p className="writingGradeSectionScoreText">
          Score: {grammar.Score}/10
        </p>
      </div>
    </div>
  );
};

export default GrammarSection;
